import React from 'react';

export const AboutSection = () => {
  return (
    <section className="section-padding" style={{ background: 'var(--bg-secondary)', padding: '100px 0' }}>
      <div className="container">
        <div style={{
          textAlign: 'center',
          maxWidth: '900px',
          margin: '0 auto 80px'
        }}>
          <h2 className="hero-medium" style={{ marginBottom: '24px', letterSpacing: '1px' }}>
            One Country. Thousands of Stories.
          </h2>
          <div style={{ 
            width: '80px', 
            height: '2px', 
            background: 'var(--text-primary)', 
            marginBottom: '32px',
            margin: '0 auto 32px'
          }} />
          <p className="body-large" style={{ 
            marginBottom: '0',
            lineHeight: 1.8, 
            color: 'var(--text-secondary)',
            fontSize: '18px'
          }}>
            Indonesia is more than Bali. Discover ancient cultures, volcanic landscapes, tropical islands, extraordinary marine life, remarkable cuisine and a coffee heritage shaped by generations.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '80px',
          alignItems: 'center',
          marginTop: '60px'
        }} className="about-grid">
          <div>
            <h3 style={{
              fontSize: '28px',
              fontFamily: "'Crimson Text', serif",
              fontWeight: 400,
              marginBottom: '24px',
              color: 'var(--text-primary)'
            }}>
              Jakarta-based. Indonesia-focused. Globally connected.
            </h3>
            <div style={{ 
              width: '60px', 
              height: '2px', 
              background: 'var(--text-primary)', 
              marginBottom: '24px' 
            }} />
            <p className="body-large" style={{ marginBottom: '20px', lineHeight: 1.7 }}>
              Indotravelista is a boutique luxury Destination Management Company specializing in curated, niche travel experiences across Indonesia for discerning travelers.
            </p>
            <p className="body-large" style={{ marginBottom: '20px', lineHeight: 1.7, color: 'var(--text-secondary)' }}>
              We craft bespoke journeys designed around interest, passion, and taste—from cultural heritage and traditional arts to specialty coffee trails and gastronomic explorations.
            </p>
            <p className="body-large" style={{ 
              lineHeight: 1.7, 
              color: 'var(--text-secondary)',
              fontStyle: 'italic',
              borderLeft: '3px solid var(--text-primary)',
              paddingLeft: '20px',
              marginTop: '32px'
            }}>
              &ldquo;Travel is not simply about arriving at a destination. It is about the journey, the experiences, the connections, and the stories we bring home.&rdquo;
            </p>
          </div>
          <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '24px'
          }}>
            <div style={{ 
              background: 'var(--bg-primary)', 
              padding: '32px 24px',
              borderRadius: 0
            }}>
              <h3 style={{ 
                fontSize: '48px', 
                fontWeight: 400,
                fontFamily: "'Crimson Text', serif",
                color: 'var(--text-primary)',
                marginBottom: '8px'
              }}>
                10+
              </h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Years crafting luxury experiences
              </p>
            </div>
            <div style={{ 
              background: 'var(--bg-primary)', 
              padding: '32px 24px',
              borderRadius: 0
            }}>
              <h3 style={{ 
                fontSize: '48px', 
                fontWeight: 400,
                fontFamily: "'Crimson Text', serif",
                color: 'var(--text-primary)',
                marginBottom: '8px'
              }}>
                500+
              </h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Bespoke journeys designed
              </p>
            </div>
            <div style={{ 
              background: 'var(--bg-primary)', 
              padding: '32px 24px',
              borderRadius: 0
            }}>
              <h3 style={{ 
                fontSize: '48px', 
                fontWeight: 400,
                fontFamily: "'Crimson Text', serif",
                color: 'var(--text-primary)',
                marginBottom: '8px'
              }}>
                17,000+
              </h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Islands to explore
              </p>
            </div>
            <div style={{ 
              background: 'var(--bg-primary)', 
              padding: '32px 24px',
              borderRadius: 0
            }}>
              <h3 style={{ 
                fontSize: '48px', 
                fontWeight: 400,
                fontFamily: "'Crimson Text', serif",
                color: 'var(--text-primary)',
                marginBottom: '8px'
              }}>
                300+
              </h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Cultures & languages
              </p>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 1024px) {
          .about-grid {
            grid-template-columns: 1fr !important;
            gap: 50px !important;
            text-align: center;
          }
          
          .about-grid > div:last-child {
            margin: 0 auto;
            max-width: 500px;
          }
        }
      `}</style>
    </section>
  );
};
